import { createUI, createVolumeUI } from './App';
export default class UI {
    constructor() {
        createUI();
        createVolumeUI();
    }
}
